import AddIcon from "@mui/icons-material/Add";
import CallIcon from "@mui/icons-material/Call";
import EditIcon from "@mui/icons-material/Edit";
import LoopIcon from "@mui/icons-material/Loop";
import PortraitIcon from "@mui/icons-material/Portrait";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Search from "../../../../components/inputs/search";
import { resetAllSummeryData } from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import CreateUser from "../../customer/create/form";
const Step2 = ({ dataS, setDataS }) => {
  const [data, setData] = useState([]);
  const [Idata, setIData] = useState([]);
  const [hasChecked, setHasChecked] = useState(false);
  const dispatch = useDispatch();
  const [last, setLast] = useState();
  const [dataUser, setDataUser] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const [editMode, setEditMode] = useState(false);
  const { userInfo } = userLogin;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchData, setSearchData] = useState("");
  const isMd = useMediaQuery("(min-width:756px)");
  useEffect(() => {
    getData();
  }, []);
  const getData = (search, reset) => {
    setLoading(true);
    axiosInstance
      .get(
        API.info.buyer +
          `?guidStateRecNo=${company?.guidRecNo}${
            search ? `&chSearchValue=${search}` : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if ((!search && Idata.length === 0) || reset) setIData(res?.data?.data);
        setData(res?.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        /*   if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (userInfo) {
        setLoading(true);
        setHasChecked(false);
        if (searchData && searchData !== "undefined" && !hasChecked) {
          getData(searchData);
        } else {
          setLoading(false);
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [userInfo, searchData, hasChecked]);
  useEffect(() => {
    getIds();
  }, []);
  const getIds = () => {
    axiosInstance
      .get(API.info.buyerLast + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setDataUser({
          ...dataUser,
          chSaleSoftID: res.data.data.chNextSaleSoftID,
        });
        setLast(res.data.data.chNextSaleSoftID);
      })
      .catch((err) => {});
  };
  const handleSumbit = () => {
    setLoadingSubmit(true);
    if (editMode) {
      axiosInstance
        .put(
          API.info.customerSingle,
          {
            ...dataUser,
            guidStuffRecNo: dataUser?.guidStuffRecNo?.guidRecNo,
            guidStateRecNo: company?.guidRecNo,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          if (res?.data?.isSuccess) {
            getIds();
            navigate(location.pathname);
            getData("", true);
            dispatch(resetAllSummeryData());
          } else {
            toast.error(res?.data?.message);
          }
          setLoadingSubmit(false);
        })
        .catch((err) => {
          toast.error("خطایی رخ داده است مجدد تلاش کنید");
          setLoadingSubmit(false);
        });
    } else {
      axiosInstance
        .post(
          API.info.customerSingle,
          {
            ...dataUser,
            guidStateRecNo: company?.guidRecNo,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo?.token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
              "Accept-Language": "fa-IR",
              chHostName: process.env.REACT_APP_CHHOSTNAME,
            },
          }
        )
        .then((res) => {
          if (res?.data?.isSuccess) {
            getIds();
            navigate(location.pathname);
            getData("", true);

            dispatch(resetAllSummeryData());
          } else {
            toast.error(res?.data?.message);
          }
          setLoadingSubmit(false);
        })
        .catch((err) => {
          toast.error("خطایی رخ داده است مجدد تلاش کنید");
          setLoadingSubmit(false);
        });
    }
  };
  return (
    <div>
      <div className="flex flex-col gap-4 md:grid grid-cols-3 p-2">
        <div className=" col-span-3 ">
          <div className=" border-b pb-2 mb-2  ">
            <div className=" flex items-end justify-between gap-4">
              {" "}
              <div className="flex gap-1 mt-5 items-center">
                <span className="text-sm font-bold text-main">
                  تعداد موارد یافت شده :‌
                </span>
                <span className="text-sm font-bold text-main">
                  {(searchData ? data : Idata)?.length}
                </span>
              </div>
              {isMd && (
                <div className="mt-4">
                  <Search
                    search={searchData}
                    setSearch={(e) => setSearchData(e.target.value)}
                  />
                </div>
              )}
              <div className="flex gap-3 items-center">
                <Button
                  onClick={() => {
                    setDataUser({ chSaleSoftID: last });
                    setEditMode(false);
                    navigate("#User");
                  }}
                  variant="contained"
                  sx={{
                    padding: "5px !important",
                    minWidth: "40px !important",
                  }}
                >
                  <AddIcon />
                </Button>
                <IconButton
                  onClick={() => getData()}
                  sx={{ padding: "0px !important" }}
                >
                  <LoopIcon
                    color="primary"
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "light"
                          ? ""
                          : "#fff  !important",
                    }}
                  />
                </IconButton>
              </div>
            </div>
            {!isMd && (
              <div className="mt-4">
                <Search
                  search={searchData}
                  setSearch={(e) => {
                    setSearchData(e.target.value);
                    setHasChecked(true);
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <>
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />{" "}
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />{" "}
            <Skeleton
              variant="rounded"
              width={"100%"}
              animation="wave"
              height={140}
            />
          </>
        ) : (
          <>
            {(searchData ? data : Idata)?.map((item, index) => (
              <Fragment key={index}>
                <Box
                  className={`flex relative z-50 flex-col  border border-solid p-4 rounded-md ${
                    dataS?.guidBuyerRecNo !== item.guidRecNo
                      ? "unSelectedBox"
                      : "selectedBox"
                  }`}
                >
                  <div
                    onClick={() =>
                      setDataS({ ...dataS, guidBuyerRecNo: item?.guidRecNo })
                    }
                    className="relative pb-4"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-sm font-bold">
                        {item?.chSaleSoftID}
                      </span>
                      <span className="text-sm font-bold">
                        {item?.chBuyerTypeName}
                      </span>
                    </div>
                  </div>

                  <span
                    onClick={() =>
                      setDataS({ ...dataS, guidBuyerRecNo: item?.guidRecNo })
                    }
                    className="text-sm font-bold"
                  >
                    {item?.chName}
                  </span>
                  <div
                    onClick={() =>
                      setDataS({ ...dataS, guidBuyerRecNo: item?.guidRecNo })
                    }
                    className="flex items-center gap-2 mt-3"
                  >
                    {item.chBuyerTypeCode === "Legal" || !item.chMobile ? (
                      <>
                        <PortraitIcon sx={{ width: "1rem" }} />
                        <span className="text-xs font-bold">
                          {item.chNationalID}
                        </span>
                      </>
                    ) : (
                      <>
                        <CallIcon sx={{ width: "1rem" }} />
                        <span className="text-xs font-bold">
                          {item.chMobile}
                        </span>
                      </>
                    )}
                  </div>

                  <IconButton
                    sx={{
                      position: "absolute",
                      right: "8px",
                      top: "12px",
                      zIndex: 9999,
                    }}
                    onMouseDown={() => {
                      setEditMode(true);
                      setDataUser(item);
                    }}
                  >
                    <EditIcon
                      onClick={() => navigate("#User")}
                      color="warning"
                    />
                  </IconButton>
                </Box>
              </Fragment>
            ))}
          </>
        )}
      </div>
      <Modal
        open={location.hash === "#User"}
        onClose={() => {
          navigate(location.pathname);
          setDataUser({ chSaleSoftID: last });
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: "80%", xs: "100%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            overflow: "auto",
            maxHeight: { md: "95%", xs: "100%" },
            height: { md: "auto", xs: "100%" },
            maxWidth: { md: "1200px" },
          }}
        >
          {" "}
          <CreateUser
            data={dataUser}
            setData={setDataUser}
            handleSumbit={handleSumbit}
            loadingSubmit={loadingSubmit}
            isModal
          />
        </Box>
      </Modal>
    </div>
  );
};

export default Step2;
